const SUMMIT_REGISTRATION_EVENT_NAME = "summit_registration_completed" as const;

export type SummitRegistrationRegistrationType =
  | "authenticated"
  | "unauthenticated";

interface SummitRegistrationTrackingPayload {
  summitId: string;
  summitTitle: string;
  registrationType: SummitRegistrationRegistrationType;
}

interface SummitRegistrationDataLayerEvent
  extends SummitRegistrationTrackingPayload,
    Record<string, unknown> {
  event: typeof SUMMIT_REGISTRATION_EVENT_NAME;
}

export function trackSummitRegistrationCompleted(
  payload: SummitRegistrationTrackingPayload,
): void {
  if (typeof window === "undefined") {
    return;
  }

  const dataLayerEvent: SummitRegistrationDataLayerEvent = {
    event: SUMMIT_REGISTRATION_EVENT_NAME,
    ...payload,
  };

  window.dataLayer?.push(dataLayerEvent);

  if (typeof window.gtag === "function") {
    window.gtag("event", SUMMIT_REGISTRATION_EVENT_NAME, {
      summit_id: payload.summitId,
      summit_title: payload.summitTitle,
      registration_type: payload.registrationType,
    });
  }

  if (typeof window.fbq === "function") {
    window.fbq("track", "CompleteRegistration", {
      content_name: payload.summitTitle,
      content_category: "Summit",
      content_ids: [payload.summitId],
      registration_type: payload.registrationType,
    });
  }
}
